import React from 'react';
import { Grid, Card, CardContent, Typography } from '@mui/material';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import FileCopyIcon from '@mui/icons-material/FileCopy';
import QuickActionButton from './QuickActionButton';

const QuickActionsSection = ({ onNavigate }) => {
  const quickActions = [
    {
      title: 'Support Tickets',
      icon: <SupportAgentIcon />,
      route: '/support-tickets',
      description: 'View and manage support tickets',
    },
    {
      title: 'New Client',
      icon: <PersonAddIcon />,
      route: '/clients/new',
      description: 'Create a new client account',
    },
    {
      title: 'View All Agreements',
      icon: <FileCopyIcon />,
      route: '/contracts',
      description: 'Manage all agreements',
    },
    {
      title: 'View All Clients',
      icon: <PeopleAltIcon />,
      route: '/clients',
      description: 'Manage all clients',
    },
  ];

  return (
    <Grid item xs={12}>
      <Card
        sx={{
          mb: 3,
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          color: 'white',
          borderRadius: 3,
        }}
      >
        <CardContent sx={{ p: 4 }}>
          <Typography variant="h5" gutterBottom sx={{ fontWeight: 600, mb: 3 }}>
            🚀 Quick Actions
          </Typography>
          <Grid container spacing={3}>
            {quickActions.map((action) => (
              <Grid item xs={12} sm={6} md={3} key={action.title}>
                <QuickActionButton
                  title={action.title}
                  icon={action.icon}
                  onClick={() => onNavigate(action.route)}
                  description={action.description}
                />
              </Grid>
            ))}
          </Grid>
        </CardContent>
      </Card>
    </Grid>
  );
};

export default QuickActionsSection;
